export default "__VITE_ASSET__BjhCuPOP__"